// extracted by mini-css-extract-plugin
export default {"productGrid":"CZ-z","centerLink":"DZ-z","productSection":"EZ-z","item":"FZ-z","ctaButton":"GZ-z"};